import {Text} from '@priority-software/priority-style-react';
import React from 'react';
import cx from 'classnames';
import {highlightText} from '../../../../_legacy/library/utils/highlightText';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

interface Props {
    value?: string;
    children?: React.ReactNode;
    query: string;
    isDateTime?: boolean;
    isActive: boolean;
    testId: string;
    bold?: boolean;
}
const Item = ({value, query, isDateTime, children, isActive, testId, bold}: Props) => {
    const dataTestId = testId && createDataTestId(`report-list-${testId}`);
    return (
        <div className={cx(styles.tableItem, styles.ellipsis)} {...dataTestId}>
            {children ? (
                children
            ) : (
                <Text
                    fontWeight={bold ? 'bold' : 'normal'}
                    componentClasses={cx(styles.text, {
                        [styles.ltr]: isDateTime
                    })}
                    skin="paragraph-2"
                    textColor={isActive ? 'primary-700' : 'secondary-300'}
                >
                    {highlightText(value, query)}
                </Text>
            )}
        </div>
    );
};

export default Item;
